import { IconRegistry } from '@lambdacurry/component-library';
import * as icons from 'lib/icons';

export const IconProvider = ({ children }) => <IconRegistry icons={icons}>{children}</IconRegistry>;
